import * as React from "react";
import { forwardRef } from "react";
const SvgActiveGreenIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 6, r: 3, fill: "#11A962" }));
const ForwardRef = forwardRef(SvgActiveGreenIcon);
export default ForwardRef;
